import React from 'react';
import SEO from '../components/SEO';
import Reveal from '../components/ui/Reveal';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT = `<h2>Our Philosophy</h2>

<p>St. Andrews World School’s educational philosophy is to provide child-centric education through our uniquely crafted academics. Our modern schooling education equally focuses on the interactive and experiential part of learning. We want to impart knowledge that can help them with real-world situations and not be just limited to the classroom. We have adopted modern schooling education where we work towards promoting the academic success of the student. We ensure that their every achievement is celebrated and they feel motivated. St. Andrews World School dedicatedly works toward holistic development. Our core values work in synchronization with our philosophy of ‘Education for all’- emphasizing the success of students. St. Andrews World School has a student-centric curriculum, where the teachers and parents equally work for the student’s academic prowess.</p>`;

const OurPhilosophy = () => {
  const title = 'Our Philosophy';
  const pageData = usePage('our-philosophy', { content: DEFAULT_CONTENT });

  return (
    <>
      <SEO
        slug="our-philosophy"
        title={title}
        description="St. Andrews World School’s educational philosophy focuses on child-centric, interactive, and experiential learning."
        keywords="Our Philosophy, SAWS Siddharth Vihar, St Andrews World School Siddharth Vihar"
      />

      {/* HERO */}
      <section className="page-hero">
        {!pageData.loading && (
        <img
            src={pageData.bannerImage || `${process.env.PUBLIC_URL}/images/page-banners/why-choose-us.jpg`}
            alt="Our Philosophy"
            className="page-hero-img"
            loading="eager"
          />
        )}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner">
              <div className="w-full max-w-[980px]">

                <Reveal delayMs={70} className="mt-4">
                  <h1 className="h-display text-4xl sm:text-5xl lg:text-6xl text-center md:text-left">
                    {title}
                  </h1>
                </Reveal>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CONTENT (unchanged) */}
      <section className="content-page">
        <div className="container">
          <div className="card p-7 md:p-10">
            <div className="text-body leading-relaxed" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default OurPhilosophy;
